import { LOGO_MAPPING } from "@sourcewhale/shared/src/assets/js/src/general/utils";

const LOCALE_WHITELIST = ["en-GB", "en-US"];
const userLocale = new Intl.NumberFormat().resolvedOptions().locale;
const LOCALE = LOCALE_WHITELIST.includes(userLocale) ? userLocale : "en-GB";

// Company links
export const LINK_KEYS = [
  "website",
  "linkedinUrl",
  "twitterUrl",
  "facebookUrl",
  "crunchbaseUrl",
  "githubUrl",
  "wikipediaUrl",
];

// Some extra / overriding links not in LOGO_MAPPING
const LINK_MAP = {
  ...LOGO_MAPPING,
  "linkedin.com": "fab fa-linkedin",
  "facebook.com": "fab fa-facebook",
  "crunchbase.com": "fas fa-link",
  wikipedia: "fab fa-wikipedia-w",
};

export const mapLinkToLogo = (link) => {
  const key = Object.keys(LINK_MAP).find((k) => link.includes(k));
  return key ? LINK_MAP[key] : "fa-solid fa-globe";
};

/// Functions for formatting the company insights store
const formatList = (list) => (list instanceof Array ? list.join(", ") : list);

// Check if any fields are arrays and convert to comma separated strings
export const formatText = ($store) => {
  if (!$store) return;

  const INSIGHT_TEXT_KEYS = [
    "name",
    "description",
    "foundedYear",
    "industries",
    "employees",
    "revenueRange",
    "fundingTotal",
    "valuation",
  ];

  INSIGHT_TEXT_KEYS.forEach((k) => {
    $store[k] = formatList($store[k]);
  });
};

// Group city and country together
export const formatLocation = ($store) => {
  const { city, country } = $store;
  if (city && country) $store.location = `${city}, ${country}`;
  else if (city) $store.location = city;
  else if (country) $store.location = country;
};

// Only show one of employees or employeeRange
export const formatEmployees = ($store) => {
  const { employees, employeeRange } = $store;
  if (employees) $store.employeeInfo = employees;
  else if (employeeRange) $store.employeeInfo = employeeRange;
};

// Group author and source together for news articles
const formatNewsSource = (article) => {
  // Sometimes there's html junk in these fields, we remove it here
  ["author", "source"].forEach((k) => {
    if (article[k]) article[k] = article[k].replace(/<[^>]*>?/gm, "");
  });

  const { author, source } = article;
  return author && source ? `${author}, ${source}` : author || source;
};

export const formatNews = ($store) => {
  if (!$store.news) return;

  // Group author and source together for news articles
  $store.news.forEach((article) => {
    article.authorAndSource = formatNewsSource(article);
  });
};

export const formatJobs = ($store) => {
  if (!$store.jobs) return;

  $store.jobs.forEach((job) => {
    // Convert arrays to strings with comma separated values
    job.industries = formatList(job.industries);
    job.contractTypes = formatList(job.contractTypes);
  });
};

export const formatDateWithOrdinal = (string) => {
  const date = new Date(string);

  const getOrdinalSuffix = (n) => {
    if (n >= 11 && n <= 13) return "th";
    switch (n % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const day = date.getDate();
  const month = date.toLocaleString(LOCALE, { month: "short" });
  const year = date.getFullYear();

  const suffix = getOrdinalSuffix(day);

  return LOCALE === "en-US"
    ? `${month} ${day}${suffix}, ${year}`
    : `${day}${suffix} ${month}, ${year}`;
};

export const showItem = (item, selectedTags) => {
  if (!item) return false;
  const tags = item.tags || [];

  return (
    !selectedTags ||
    !selectedTags.length ||
    tags.some((tag) => selectedTags.includes(tag))
  );
};
